
import Vue from "vue"
import Component from "vue-class-component"
import {QBtn} from "quasar"
import {Prop} from "vue-property-decorator"

@Component({components: {QBtn}})
export default class ExpandButton extends Vue {
  @Prop()
  value: boolean

  get expand(): boolean {
    return this.value
  }

  set expand(expand: boolean) {
    this.$emit("input", expand)
  }
}
